import { Route, Routes } from "react-router-dom";
import { LandingVotingPage } from "./LandingVotingPage";
import React, { createContext, useCallback, useEffect, useState } from "react";
import { Meeting } from "../../api/models/Meeting";
import { NotFoundPage } from "./NotFoundPage";
import { InfoPage } from "./InfoPage";
import { ActionPage } from "./ActionPage";
import { PhonePage } from "./PhonePage";
import { HomePage } from "./HomePage";
import { api } from "../../api/api";

type VotingContextType = {
  name: string;
  setName: React.Dispatch<React.SetStateAction<string>>;
  authorName: string;
  meeting: Meeting | null;
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setAuthorName: React.Dispatch<React.SetStateAction<string>>;
  setMeeting: React.Dispatch<React.SetStateAction<Meeting | null>>;
  meetingError?: any;
  setMeetingError: React.Dispatch<React.SetStateAction<any>>;
  voteId: null | string;
  setVoteId: React.Dispatch<React.SetStateAction<string | null>>;
  getMeeting: (meetingId: string) => void;
};

const VotingContextDefault = {
  name: "",
  setName: () => {},
  authorName: "",
  meeting: null,
  isLoading: false,
  setIsLoading: () => {},
  setAuthorName: () => {},
  setMeeting: () => {},
  meetingError: null,
  setMeetingError: () => {},
  voteId: null,
  setVoteId: () => {},
  getMeeting: (meetingId: string) => {},
};

export const VotingContext =
  createContext<VotingContextType>(VotingContextDefault);

export const VotingNavigation = () => {
  const [name, setName] = useState("");
  const [authorName, setAuthorName] = useState("");
  const [meeting, setMeeting] = useState<Meeting | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [meetingError, setMeetingError] = useState(null);
  const [voteId, setVoteId] = useState<string | null>(null);

  const getMeeting = useCallback((meetingUuid: string) => {
    setIsLoading(true);
    api.meetings
      .getMeeting(meetingUuid)
      .then((res) => {
        if (res.data) {
          setMeeting(res.data);
          if (res.data?.author?.name) {
            setAuthorName(res.data?.author?.name);
          } else if (res.data?.author?.nametag) {
            setAuthorName(res.data?.author?.nametag);
          }
        } else {
          setMeeting(null);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        setMeetingError(e);
        setIsLoading(false);
      });
  }, []);

  return (
    <VotingContext.Provider
      value={{
        name,
        setName,
        authorName,
        meeting,
        isLoading,
        setIsLoading,
        setAuthorName,
        setMeeting,
        meetingError,
        setMeetingError,
        voteId,
        setVoteId,
        getMeeting,
      }}
    >
      <Routes>
        <Route path={"/app/:meetingUuid"} element={<LandingVotingPage />} />
        <Route path={"/app/not-found"} element={<NotFoundPage />} />
        <Route path={"/app/action/:meetingUuid"} element={<ActionPage />} />
        <Route path={"/app/phone"} element={<PhonePage />} />
        <Route path={"/app"} element={<HomePage />} />
      </Routes>
    </VotingContext.Provider>
  );
};
